import { useEffect } from "react";
import { Link } from "react-router-dom";
import { loadUsetifulScript, setUsetifulTags } from "usetiful-sdk";
import { useAppState } from "@/modules/app/useAppContext";
import { useFeatureFlag } from "@/helpers/useFeatureFlag";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Button,
} from "@altimateai/lego";

interface TourItem {
  label: string;
  path: string;
  children?: TourItem[];
  id: string;
}

const tourItems: TourItem[] = [
  {
    label: "Overall Product Tour",
    path: "/summary",
    id: "tour-overall",
  },
  {
    label: "Cost & Savings",
    path: "/summary",
    id: "tour-summary-cost-savings",
  },
];

const ProductTour = () => {
  const showTour = useFeatureFlag("tour");
  const { loggedinUser: user } = useAppState();

  useEffect(() => {
    if (showTour && user) {
      setUsetifulTags({
        userId: user?.id,
        firstName: user?.first_name,
        lastName: user?.last_name,
      });
    }
  }, [showTour, user]);

  useEffect(() => {
    if (showTour) {
      loadUsetifulScript("437bd2ad93b0d73bf6779ba6c34c2cd9"); // This contains your unique token key
    }
  }, [showTour]);

  if (!showTour) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={"secondary"} size="sm">
          Start Product Tour
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {tourItems.map((item, index) => (
          <DropdownMenuItem key={index} asChild>
            <Link to={item.path} id={item.id}>
              {item.label}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProductTour;
